import React, { useState, useRef, useEffect } from "react";
import GlobalIcon from "../../images/navbar/global-icon.svg";
import TriangleIcon from "../../images/navbar/triangle-icon.svg";
import EmeaIcon from "../../images/navbar/emea-icon.svg";
import { handleRegionChange } from "../../utils/regionUtils";
import globalStrings from "../../config/index";

const GeolocationDropdown = () => {
  const [open, setOpen] = useState(false);
  const [isEmea, setIsEmea] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  const { itemGlobal, itemEmea } = globalStrings.geolocation.dropdown;

  useEffect(() => {
    setIsEmea(window.location.pathname.startsWith("/emea"));
  }, []);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const options = [
    {
      id: "global",
      label: itemGlobal,
      icon: GlobalIcon,
      alt: "Global region icon",
    },
    {
      id: "emea",
      label: itemEmea,
      icon: EmeaIcon,
      alt: "Emea region icon",
    },
  ];

  return (
    <div className="relative" ref={ref}>
      <button
        className="flex items-center gap-1 bg-[rgba(239,243,244,1)] border-none p-1 cursor-pointer rounded"
        onClick={() => setOpen((s) => !s)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span>
          <img src={isEmea ? EmeaIcon : GlobalIcon} alt="Global region icon" />
        </span>

        <span
          className={`${
            open ? "open transform rotate-180 -translate-y-0.5" : ""
          }`}
        >
          <img src={TriangleIcon} alt="Dropdown triangle" />
        </span>
      </button>

      {open && (
        <div className="absolute right-[-23px] mt-2 min-w-[104px] bg-[rgba(239,243,244,1)] text-[rgba(0,82,115,1)] rounded p-3 z-60 lg:right-0">
          {options.map((o) => (
            <button
              key={o.id}
              className="flex items-center gap-1 w-full h-6 bg-transparent border-none cursor-pointer hover:bg-[rgba(5,12,20,0.04)] mt-2 first:mt-0"
              onClick={() => {
                setOpen(false);
                handleRegionChange(o.id);
              }}
            >
              <span className="inline-flex items-center justify-center w-6 h-6">
                <img src={o.icon} alt={o.alt} />
              </span>

              <span className="text-[14px] font-semibold text-[rgba(0,82,115,1)] self-end">
                {o.label}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default GeolocationDropdown;
